import { PageComponent } from '@root/pages/Type';
import classNames from 'classnames';
import styles from './TypeIcon.module.scss';
import Icon from '@root/components/Icon';

type TypeIconProps = {
    type?: string;
    className?: string;
    active?: boolean;
};

const TypeIcon: PageComponent<TypeIconProps> = ({
    type,
    className,
    active = false,
}) => {
    let IconSrc = active
        ? '/static/img/icons/services/vps-selected.png'
        : '/static/img/icons/services/vps.png';
    switch (type?.toLowerCase()) {
        case 'vds':
            IconSrc = active
                ? '/static/img/icons/services/vds-selected.png'
                : '/static/img/icons/services/vds.png';
            break;
        case 'ds':
            IconSrc = active
                ? '/static/img/icons/services/ds-selected.png'
                : '/static/img/icons/services/ds.png';
            break;
    }
    return (
        <Icon
            src={IconSrc}
            className={classNames(className, styles['image-container'])}
        />
    );
};

export default TypeIcon;
